import axios from 'axios';

import { initialize } from 'generated';

export { queryKeys } from 'generated';

// Pass as the username path param of a generated request: the axios request
// interceptor in config/main.ts swaps it for the principal.
export const USERNAME_PLACEHOLDER = '{username}';

const config = initialize(axios);
export const { requests, queries, mutations } = config;
